import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StarredCellRendererModule } from '@y42/ag-grid';
import { ListViewModule } from '@y42/core/list-view';
import { AssetStatusCellRendererModule } from './asset-status-cell-renderer/asset-status-cell-renderer.module';
import { EntityTypeCellRendererModule } from './entity-type-cell-renderer/entity-type-cell-renderer.module';
import { EntryGroupCellRendererModule } from './entry-group-cell-renderer/entry-group-cell-renderer.module';
import { FeatureListViewHighlightActiveAssetDirective } from './feature-list-view-highlight-active-asset.directive';
import { FeatureListViewRedirectOnClickDirective } from './feature-list-view-redirect-on-click.directive';
import { FeatureListViewDirective } from './feature-list-view.directive';
import { SubEntryCellRendererModule } from './sub-entry-cell-renderer/sub-entry-cell-renderer.module';
import { TagsCellRendererModule } from './tags-cell-renderer/tags-cell-renderer.module';

@NgModule({
  imports: [
    CommonModule,
    ListViewModule,
    EntryGroupCellRendererModule,
    EntityTypeCellRendererModule,
    TagsCellRendererModule,
    SubEntryCellRendererModule,
    AssetStatusCellRendererModule,
    StarredCellRendererModule,
  ],
  declarations: [
    FeatureListViewDirective,
    FeatureListViewRedirectOnClickDirective,
    FeatureListViewHighlightActiveAssetDirective,
  ],
  exports: [
    FeatureListViewDirective,
    FeatureListViewRedirectOnClickDirective,
    ListViewModule,
    FeatureListViewHighlightActiveAssetDirective,
  ],
})
export class FeatureListViewModule {}
